import { render, staticRenderFns } from "./view-image.vue?vue&type=template&id=abf81200&scoped=true&class=component%20view-image"
import script from "./view-image.vue?vue&type=script&lang=ts"
export * from "./view-image.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abf81200",
  null
  
)

export default component.exports